import { defineMessages } from 'react-intl'

export default defineMessages({
  filtersTitle: {
    id: 'portfolio.categories.title',
    defaultMessage: 'Kategorije',
  },
})
